<template>
  <q-dialog
    v-model="shown"
  >
    <q-card
      style="min-width: 320px;"
      data-test-id="select-terminal-card"
    >
      <q-form
        ref="formRef"
      >
        <q-tabs
          v-model="tab"
        >
          <q-tab
            name="connect"
            label="Connect"
          />
          <q-tab
            name="register"
            label="Register"
          />
        </q-tabs>
        <q-tab-panels
          v-model="tab"
        >
          <q-tab-panel name="register">
            <q-card-section class="items-center q-mx-xs">
              <div
                class="row q-col-gutter-sm items-start"
              >
                <q-input
                  v-model="registrationCode"
                  class="col-12"
                  label="Registration Code"
                  hint="e.g. green-apple"
                  bottom-slots
                />
              </div>
              <div
                class="row q-col-gutter-sm items-start"
              >
                <q-input
                  v-model="label"
                  class="col-12"
                  label="Reader Label e.g. Front Desk"
                  bottom-slots
                />
              </div>
            </q-card-section>
            <q-card-actions align="right">
              <q-btn
                label="Add"
                color="primary"
                :loading="loading"
                @click="save"
              />
            </q-card-actions>
          </q-tab-panel>
          <q-tab-panel
            name="connect"
          >
            <q-card-section>
              <q-select
                v-model="selectedStripeTerminal"
                class="full-width q-mx-none"
                label="Chip Reader"
                :options="$payments.discoveredReaders"
                option-label="label"
                :disable="connectingToChipReader"
                :display-value="selectedStripeTerminal && selectedStripeTerminal.label || ''"
                data-test-id="terminal-select"
              />
            </q-card-section>

            <q-card-actions align="center">
              <q-btn
                label="Connect To Chip Reader"
                color="secondary"
                :loading="connectingToChipReader"
                data-test-id="terminal-connect-button"
                @click="connectToStripeTerminal()"
              />
            </q-card-actions>
          </q-tab-panel>
        </q-tab-panels>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>

import { Notify } from 'quasar'
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'

export default {
  name: 'SelectStripeTerminalDialog',
  mixins: [FormValidationMixin],
  data () {
    return {
      selectedStripeTerminal: null,
      connectingToChipReader: false,
      shown: false,
      tab: 'connect',
      loading: false,
      registrationCode: null,
      label: null
    }
  },
  async created () {
    await this.currentSite.ensureLoaded()
  },
  context: ['currentRegisterClient'],
  configuration: ['currentSite'],
  methods: {
    save () {
      this.validateForm(async () => {
        this.loading = true

        const result = await this.currentSite.createStripeReader(this.registrationCode, this.label)

        this.loading = false
        if (result?.data?.success) {
          window.location.reload()
          this.hide()
        }
      })
    },
    show () {
      this.shown = true
    },
    hide () {
      this.shown = false
    },
    async connectToStripeTerminal () {
      if (!this.selectedStripeTerminal || !this.currentRegisterClient) return

      this.connectingToChipReader = true

      const result = await this.$payments.terminalConnectionInitalizer(this.currentRegisterClient, this.currentRegisterClient?.stripeTerminalLocationId, false, true, this.selectedStripeTerminal)

      if (!result.error) {
        this.currentRegisterClient.stripeTerminalSerialNumber = this.selectedStripeTerminal.serial_number
        await this.currentRegisterClient.save()
        Notify.create({
          message: 'Chip Reader Connected',
          type: 'positive',
          position: 'bottom-left',
          classes: 'hardware-notify'
        })
        this.hide()
      } else {
        Notify.create({
          message: result.error,
          type: 'negative',
          position: 'bottom-left',
          classes: 'hardware-notify'
        })
      }

      this.connectingToChipReader = false
    }
  }
}
</script>
